import angular from 'angular';
import { ADVERSE_EVENT_ATTESTED, ADVERSE_EVENT_DELETED } from 'common/messages';
import templateUrl from './adverse-events.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@',
    adverseEvents: '<',
    alerts: '<',
    animalTypes: '<',
    eventTypes: '<',
    searchCriteria: '<',
    searchTypes: '<',
    sexes: '<',
    statuses: '<',
    symptoms: '<',
    injuryProbabilities: '<',
    injurySeverities: '<',
    occurrenceLikelihoods: '<',
    query: '<',
    limitOptions: '<'
  },
  controller: class AdverseEventsComponent {
    constructor($mdDialog, $scope, $state,
      AdverseEventService, AdverseEventsService,
      CompanyService,
      AuthService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        AdverseEventService,
        AdverseEventsService,
        AuthService,
        CompanyService,
        ToastService
      });

      this.onPaginationChanged = (page, take) => {
        this.query = {
          ...this.query,
          page,
          take
        };

        this.refreshResults();
      };

      this.onOrderChanged = (order) => {
        const direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        const orderBy = order.replace('-', '');

        this.query = {
          ...this.query,
          direction,
          orderBy
        };

        this.refreshResults();
      };
    }

    $onInit() {
      this.searchCriteria = this.searchCriteria || {};
      this.selectedAdverseEvents = [];
    }

    refreshResults() {
      this.AdverseEventsService.setQuery(this.query);

      if (!this.searchCriteria.selectedSearchType) {
        return;
      }

      switch (this.searchCriteria.selectedSearchType) {
        case 'Open Adverse Events':
          this.promise = this.AdverseEventsService.getAdverseEventsByStatus('OPEN');
          break;
        case 'Search by Report Date':
          if (this.searchCriteria.selectedReportDate) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsByReportDate(this.searchCriteria.selectedReportDate);
          }
          break;
        case 'Search by Product Name':
          if (this.searchCriteria.selectedProduct) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsByProduct(this.searchCriteria.selectedProduct.ProductId);
          }
          break;
        case 'Search by Ingredient Name':
          if (this.searchCriteria.selectedIngredient) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsByIngredient(this.searchCriteria.selectedIngredient.UserIngredientId);
          }
          break;
        case 'Search by System Ingredient':
          if (this.searchCriteria.selectedIngredient) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsBySystemIngredient(this.searchCriteria.selectedIngredient.SystemIngredientId);
          }
          break;
        case 'Search by Member':
          if (this.searchCriteria.selectedCompany) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsByMember(this.searchCriteria.selectedCompany.MemberId);
          }
          break;
        case 'Search by Event (any events)':
          if (this.searchCriteria.selectedEventTypes) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsByType(this.searchCriteria.selectedEventTypes, false);
          }
          break;
        case 'Search by Event (all matched events)':
          if (this.searchCriteria.selectedEventTypes) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsByType(this.searchCriteria.selectedEventTypes, true);
          }
          break;
        case 'Search by Species':
          if (this.searchCriteria.selectedSpecies) {
            this.promise = this.AdverseEventsService
              .getAdverseEventsBySpecies(this.searchCriteria.selectedSpecies);
          }
          break;
        case 'Search by Text':
          if (this.searchCriteria.searchByText) {
            this.promise = this.AdverseEventsService.getAdverseEventsByText(this.searchCriteria.searchByText);
          }
          break;
        case 'Missing Event Information':
          this.promise = this.AdverseEventsService.getAdverseEventsMissingInfo();
          break;
        default:
          this.promise = this.AdverseEventsService.getAdverseEvents();
      }

      if (!this.promise) {
        this.promise = this.AdverseEventsService.getAdverseEvents();
      }

      this.promise.then((r) => {
        this.adverseEvents = {
          Count: r.data.Count,
          Data: r.data.Data
        };

        this.promise = undefined;
      }).catch(error => this.ToastService.showError(error));
    }

    onSearchChanged({ searchCriteria }) {
      this.searchCriteria = searchCriteria;
      this.query = {
        ...this.query,
        searchText: this.searchCriteria.searchText,
        seriousAEsOnly: this.searchCriteria.seriousAEsOnly
      };

      this.refreshResults();
    }

    searchTextChanged($event) {
      this.query = {
        ...this.query,
        searchText: $event.searchText
      };

      this.refreshResults();
    }

    searchByTextChanged({ searchByText }) {
      this.searchCriteria.searchByText = searchByText;
      this.refreshResults();
    }

    onEditClicked(adverseEventId) {
      this.$state.go('adverseEventEdit', { id: adverseEventId });
    }

    onViewClicked(adverseEventId) {
      this.AdverseEventService.getAdverseEvent(adverseEventId).then((r) => {
        const adverseEvent = r.data;

        this.AdverseEventService.getProductsByCompany(adverseEvent.MemberId).then((rp) => {
          const products = rp.data;

          this.CompanyService.getCompany(adverseEvent.MemberId).then((rc) => {
            const company = rc.data;

            if (!company.IsAllowMultiProductPerAE
              && adverseEvent.ProductIds
              && adverseEvent.ProductIds.length) {
              adverseEvent.ProductIds = adverseEvent.ProductIds[0];
            }

            const scope = angular.extend(this.$scope.$new(true), {
              adverseEvent,
              symptoms: this.symptoms,
              animalTypes: this.animalTypes,
              sexes: this.sexes,
              injurySeverities: this.injurySeverities,
              injuryProbabilities: this.injuryProbabilities,
              occurrenceLikelihoods: this.occurrenceLikelihoods,
              statuses: this.statuses,
              products
            });

            this.$mdDialog.show({
              clickOutsideToClose: true,
              fullscreen: true,
              scope,
              template: `
            <md-dialog class="flex-75" style="max-height: 75%">
              <md-dialog-content class="naers-dialog-content">
                <dialog-close/>
                <case-reference adverse-event="adverseEvent" 
                  locked="true" layout="column" flex>
                </case-reference>
                <contact-list adverse-event="adverseEvent"
                  show-header="true" locked="true" layout="column" flex>
                </contact-list>
                <adverse-event-information adverse-event="adverseEvent" symptoms="symptoms"
                  products="products"
                  locked="true" layout="column" flex>
                </adverse-event-information>
                <animal-information adverse-event="adverseEvent" animal-types="animalTypes"
                  sexes="sexes" locked="true" layout="column" flex>
                </animal-information>

                <animal-history adverse-event="adverseEvent" locked="true"
                  layout="column" flex>
                </animal-history>

                <risk-analysis adverse-event="adverseEvent" injury-severities="injurySeverities"
                  injury-probabilities="injuryProbabilities" occurrence-likelihoods="occurrenceLikelihoods"
                  locked="true" layout="column" flex>
                </risk-analysis>
                <closure adverse-event="adverseEvent"
                  statuses="::statuses"
                  locked="true" layout="column" flex>
                </closure>
              </md-dialog-content>
            </md-dialog>
          `
            });
          });
        });
      }).catch(error => this.ToastService.showError(error));
    }

    alertClicked({ alert }) {
      if (alert) {
        if (alert.AlertTypeID === 2) {
          this.searchCriteria = {
            ...this.searchCriteria,
            selectedSearchType: 'Open Adverse Events'
          };
          this.refreshResults();
        } else if (alert.AlertTypeID === 4) {
          if (this.AuthService.isSysAdmin) {
            this.$state.go('memberCompliance');
          } else {
            this.showAttestment();
          }
        }
      }
    }

    showAttestment() {
      this.AdverseEventsService.getOpenAdverseEventsPreviousMonth().then((r) => {
        const adverseEvents = r.data;
        const scope = angular.extend(this.$scope.$new(true), {
          adverseEvents,
          onAttested: $event => this.onAttested($event)
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope,
          template: `
            <md-dialog class="flex-75" style="max-height: 75%">
              <md-dialog-content>
                <dialog-close/>
                <attest
                  adverse-events="adverseEvents"
                  on-attested="onAttested($event)">
                </attest>
              </md-dialog-content>
            </md-dialog>
          `
        });
      }).catch(error => this.ToastService.showError(error));
    }

    onAttested({ signature }) {
      if (signature) {
        this.AdverseEventService.attest(signature)
          .then(() => {
            this.ToastService.showSuccess(ADVERSE_EVENT_ATTESTED);
            this.$mdDialog.hide();
            this.$state.reload();
          }).catch(error => this.ToastService.showError(error));
      }
    }

    onDeleteClicked(adverseEvents) {
      const confirm = this.$mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Once deleted, the selected adverse event(s) cannot be recovered!')
        .ok('Delete')
        .cancel('Cancel');

      this.$mdDialog.show(confirm).then(() => {
        const promises = [];
        for (let i = adverseEvents.length - 1; i >= 0; i -= 1) {
          promises.push(this.AdverseEventService.delete(adverseEvents[i].AEId));
        }

        Promise.all(promises).then(() => {
          this.ToastService.showSuccess(ADVERSE_EVENT_DELETED);
          this.refreshResults();
          this.selectedAdverseEvents = [];
        }).catch(error => this.ToastService.showError(error));
      });
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-events.component.js